import * as Yup from 'yup';
import { emailRegex } from '../../util/validations';
import { useTranslation } from '../../hooks/useTranslation';

type TFunction = ReturnType<typeof useTranslation>['t'];

export const INVITE_MEMBERS_VALIDATION = (t: TFunction) => {
    return Yup.object().shape({
        email: Yup.string().matches(emailRegex, t('validationMessages.INVITE_MEMBERS_VALIDATION.email.matches')).min(6).max(320),
    });
};
